/**
 * LE SCHEDE DI SEZIONE SOTTO I 360 — una regola sola per le due righe di schede: quella della Hub (`HubSections`) e
 * quella della rotta `/backgammon` (`BackgammonSectionTabs`). [I-362, layout-tma-orcb-7-etichette, 2026-10-04]
 *
 * A 320 la colonna da quattro lascia 58 px di testo, e a 10 px maiuscolo (sotto non si scende) non ci stanno
 * CLASSIFICA, STATISTICHE, POSICIONES, MY BOARDS, ΕΚΔΗΛΩΣΕΙΣ, ΑΠΟΣΤΟΛΕΣ: andavano in ellissi. Sotto i 360 la riga
 * smette di essere una griglia a colonne uguali e diventa una fila in cui ogni scheda parte dalla larghezza del SUO
 * testo (`flex-auto`): lo spazio che avanza alle corte («LIVE», «GIOCA») va alle lunghe. Nessuna parola nuova.
 * Da 360 in su resta la griglia di prima, al pixel. Il tocco: mai sotto 44 di larghezza (`min-w-11`).
 *
 * ⚠️ Le colonne proporzionali vivono su righe SEPARATE: una griglia unica con le colonne condivise fra le righe non
 * regge (a 320, in italiano, le quattro colonne piu' larghe sommano 275 px contro 264). Per questo anche la rotta
 * va a righe da quattro, come la Hub.
 *
 * Cio' che lo tiene fermo: `tests/schede-sezione-320.test.tsx` (le classi, in jsdom) e la misura nel browser della PR
 * (ellissi per scheda a 320, 360, 390 in it/en/es/el).
 */

/** La riga di (al massimo) quattro schede: griglia da 360 in su, fila proporzionale al testo sotto. */
export const RIGA_SCHEDE = 'grid gap-1 max-[360px]:flex';

/** La scheda sotto i 360: parte dalla larghezza del suo testo, prende la sua parte di quel che avanza, mai sotto 44. */
export const SCHEDA_STRETTA = 'max-[360px]:min-w-11 max-[360px]:flex-auto';

/** L'etichetta: larga quanto la colonna da 360 in su, quanto il suo testo sotto (e' lei che dà la base alla scheda). */
export const ETICHETTA_SCHEDA =
  'w-full truncate text-center text-[10px] font-bold uppercase tracking-wide max-[360px]:w-auto';
